import { createApp } from 'vue';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

window.Swiper = require('swiper/bundle').Swiper;

require('./bootstrap');
window.Vue = require('vue').default;

//componentes

const app = createApp({
  el: '#app',
  created() {
    this.geolocation();
  },
  mounted() {

  },
  methods: {
    /**
  * Reload.
  *
  * @param  {string} lat Latitude
  * @param  {string} lon Longitude
  * @return void
  */
    reload: function (lat, lon) {
      console.log('Has coordinates:' + this.location);
      if (this.location == 0) {
        window.location.href += "?lat=" + lat + "&lon=" + lon;
      }
    },
    /**
    * Ask browser for location coordinates.
    *
    * @return void
    */
    geolocation: async function () {
      let parent = this;
      if (window.location.href.indexOf("clima") > -1) {
        console.log('URL contains `clima`...');
        //Check browser compatibility
        if (!navigator.geolocation) {
          console.log('Geolocation is not supported by your browser');
        } else {
          //Use geolocation
          navigator.geolocation.getCurrentPosition(function (position) {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;

            console.log(`Latitude: ${latitude}, Longitude: ${longitude}`);
            //Get pronostico data
            parent.reload(latitude, longitude);
          }, function () {
            console.log('Unable to retrieve your location');
          });
        }
      }
    }
  },
  data() {
    return {
      climasList: this.climas,
      /* location: document.getElementById('hasCoordinates').getAttribute('data-value') */
    }
  }
});


app.component('VueDatePicker', VueDatePicker);
app.component('remates-preview', require('./components/RematesPreviewComponent').default);
app.component('anexo-remate-filtro', require('./components/AnexoRemateFiltroComponent').default);
app.mount('#app');


//Functions
function sliderSwiperCards(DivSwiper, direction, spv, spg, space, dynaBul) {
  var swiper = new Swiper(`${DivSwiper} .swiper-container`, {
    direction: direction,
    slidesPerView: spv,
    slidesPerGroup: spg,
    centeredSlides: false,
    spaceBetween: space,
    autoplay: {
      delay: 1000,
    },
    freeMode: false,
    loop: true,
    speed: 600,
    observer: true,
    observeParents: true,
    mousewheel: true,
    navigation: {
      nextEl: `${DivSwiper} .swiper-button-next`,
      prevEl: `${DivSwiper} .swiper-button-prev`,
    },
    grabCursor: true,
    pagination: {
      el: `${DivSwiper}  .swiper-pagination`,
      dynamicBullets: dynaBul,
      clickable: true
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      576: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      }
    }
  });

  /* if ($(window).width() <= 575) {
  if($(`${DivSwiper} .swiper-slide`).length == 1) {
    $(DivSwiper + " .swiper-pagination").addClass( "disabled" );
    }
  } */
}

/*Slider de anexo_remates.blade.php (/servicios/remates)*/
function sliderRematesanexo(DivSwiper, direction, spv, spg, space, dynaBul) {
  var swiper = new Swiper(`${DivSwiper} .swiper-container`, {
    direction: direction,
    slidesPerView: spv,
    slidesPerGroup: spg,
    centeredSlides: false,
    spaceBetween: space,
    autoplay: {
      delay: 2000,
    },
    freeMode: false,
    loop: false,
    speed: 600,
    observer: true,
    observeParents: true,
    mousewheel: true,
    navigation: {
      nextEl: `${DivSwiper} .swiper-button-next`,
      prevEl: `${DivSwiper} .swiper-button-prev`,
    },
    grabCursor: true,
    pagination: {
      el: `${DivSwiper}  .swiper-pagination`,
      dynamicBullets: dynaBul,
      clickable: true
    },
    breakpoints: {
      0: {
        slidesPerView: 1.5,
        slidesPerGroup: 1.5
      },
      500: {
        slidesPerView: 2,
        slidesPerGroup: 2
      },
      767: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      }
    }
  });
}

/* Llama a slider de anexo_remates.blade.php (/servicios/remates) en viewports menores a 1040 */
if ($(window).width() < 1040) {
  sliderSwiperCards('.sliderAnexoPartners', 'horizontal', 'auto', 1, 0, false);
}

if ($(window).width() < 768) {
  sliderRematesanexo('#ARemates', 'horizontal', 'auto', 1, 15, false);
}

const slidesCount = document.querySelectorAll('.partner').length

const partners = new Swiper('.partners', {

  slidesPerView: 2,

  loop: true,

  speed: 1000,

  breakpoints: {

    0: {

      // slidesPerView: 2,

      slidesPerView: slidesCount <= 2 ? slidesCount : 2,

      loop: slidesCount <= 2 ? false : true,

      spaceBetween: 0

    },

    768: {

      // slidesPerView: 4,

      slidesPerView: slidesCount <= 4 ? slidesCount : 4,

      loop: slidesCount <= 4 ? false : true,

      spaceBetween: 0

    },

    991: {

      // slidesPerView: 5,

      // slidesPerGroup: 5,

      slidesPerView: slidesCount <= 7 ? slidesCount : 7,

      loop: slidesCount <= 7 ? false : true,

      spaceBetween: 0

    }

  }

})

const wh = window.innerWidth

const runsRecursion =

  wh < 768 && slidesCount <= 2

    ? false

    : wh > 768 && wh <= 991 && slidesCount <= 4

      ? false

      : wh > 991 && slidesCount <= 7

        ? false

        : true



if (runsRecursion) {

  // Partners randomization

  const randomIntFromInterval = (min, max) =>

    Math.floor(Math.random() * (max - min + 1) + min)



  const recursion = () => {

    const random = randomIntFromInterval(1, partners.slides.length)

    partners.slideTo(random)



    // console.log('>> random:', random)



    setTimeout(recursion, 5000)

  }



  recursion()

}